import { createContext, useContext, useState, useEffect } from "react";
import { apiFetchAdmin } from '../../hooks/apiFetch';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useLangUrl } from '../../utilities/useLangUrl';

// import Cookies from 'js-cookie';

const AdminPaymentContext = createContext();

export function AdminPaymentProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [paymentData, setPaymentData] = useState(null);
    const [pageLimit, setPageLimit] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedPaymentStatus, setSelectedPaymentStatus] = useState(null)
    const langUrl = useLangUrl();

    const navigate = useNavigate();

    useEffect(() => {
        if (!Cookies.get('adminToken')) {
            navigate("/admin/adminLogin")
        }
        async function fetchPayment() {
            try {
                const payment = await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/payment/system-payments?${selectedPaymentStatus ? `status=${selectedPaymentStatus}&` : ""}${searchQuery ? "" : "page=" + currentPage + "&"}limit=${searchQuery ? pageLimit : 5}`);
                setPaymentData(payment);
                setPageLimit(payment?.data?.paginationInfo.totalCount)
            } catch (err) {
                setPaymentData(null);
            } finally {
                setLoading(false);
            }
        }
        fetchPayment();
    }, [navigate, currentPage, searchQuery, selectedPaymentStatus, pageLimit, langUrl]);


    return (
        <AdminPaymentContext.Provider value={{ loading, setLoading, paymentData, setPaymentData, pageLimit, setPageLimit, currentPage, setCurrentPage, searchQuery, setSearchQuery, selectedPaymentStatus, setSelectedPaymentStatus }}>
            {children}
        </AdminPaymentContext.Provider>
    );
}

export function useAdminPayment() {
    return useContext(AdminPaymentContext);
}